import { render } from "./Sensores.vue?vue&type=template&id=53848753"
import script from "./Sensores.vue?vue&type=script&lang=js"
export * from "./Sensores.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__